module.exports = __webpack_public_path__ + "static/media/pl-javascript.15a4866e.png";